
export class GetUsersCommand{
  constructor() {
  }
}
